import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ProfileIcon, LogoutIcon, AvatarIcon } from "../../SVGs";
import Menu from "../../Menu";
import { MasterDataContext } from "../../../contexts/MasterDataContext";
import { useTranslation } from "react-i18next";
import { FireBaseContext } from "../../../contexts/FireBase";
import { Typography } from "@mui/material";

const customStyles = {
  root: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    flexDirection: "row-reverse",
    color: "rgb(169, 175, 187)",
    "&:hover > svg ": {
      color: "rgb(98 195 238)",
      background: "rgb(255 255 255)",
    },
    "&:hover > svg:first-of-type": {
      borderRadius: "50%",
      border: "1px solid rgb(98 195 238)",
      zIndex: 2,
    },
  },
  active: {
    "& > svg": {
      color: "rgb(98 195 238)",
    },
  },
  profile: {
    width: "39px",
    height: "39px",
    borderRadius: "50%",
    padding: "0.35rem",
    backgroundColor: "rgb(232 235 241)",
    cursor: "pointer",
  },
  activeProfile: {
    borderRadius: "50%",
    border: "1px solid rgb(98 195 238)",
    zIndex: 2,
    color: "rgb(98 195 238)",
    background: "rgb(255 255 255)",
  },
};

const AvatarMenu = () => {
  const {
    state: {
      userDetails: { firstName },
    },
  } = useContext(MasterDataContext);
  const { logEvent } = useContext(FireBaseContext);

  const [visibility, setVisibility] = useState("hidden");
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const handleClick = () => {
    setVisibility(visibility === "hidden" ? "visible" : "hidden");
  };

  const greetingMessage = firstName
    ? `${t("Welcome")} ${firstName}`
    : t("Welcome");

  const avatarMenuItems = [
    {
      name: "profile",
      action: null,
      label: greetingMessage,
      Icon: <AvatarIcon color="rgb(255 255 255)" />,
    },
    {
      name: "signout",
      action: () => {
        logEvent("ClickOnLogout");
        const restoreId = localStorage.getItem("restoreId");
        localStorage.clear();
        if (restoreId) localStorage.setItem("restoreId", restoreId);
        navigate("/login");
      },
      label: t("Sign Out"),
      Icon: <LogoutIcon style={{ cursor: "pointer" }} />,
    },
  ];

  return (
    <Typography component="div" sx={customStyles.root} onClick={handleClick}>
      <ProfileIcon sx={customStyles.profile} />
      <Menu
        menuItems={avatarMenuItems}
        blue
        visible={visibility}
        align={i18n.dir() === "rtl" ? "left" : "right"}
      />
    </Typography>
  );
};

export default AvatarMenu;
